import Env from "../base/env.js";
import Channels from "../base/channels.js";
import hoverIntent from "hoverintent";
import gsap from "gsap";
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(SplitText);

class MainnavTouch {
  constructor() {
    if (Env.$mainNav == null) {
      return false;
    }
    this.DOM = {};
    this.DOM.view = Env.$mainNav;
    this.DOM.menu = this.DOM.view.querySelector(".jsMenu");
    this.DOM.close = this.DOM.view.querySelector(".jsClose");

    this.DOM.triggers = Env.$body.querySelectorAll(".jsMainnav--trigger");

    this.DOM.triggerModel = this.DOM.view.querySelector(".jsModelTrigger");
    this.DOM.triggerCloseModel = this.DOM.view.querySelector(".jsModelClose");
    this.DOM.navSlideshow = this.DOM.view.querySelector(".jsNavSlideshow");

    this.DOM.fill = this.DOM.view.querySelector(".jsFill");

    this.DOM.primary = this.DOM.view.querySelector(".jsMainnav");
    this.DOM.primaryItems = this.DOM.view.querySelectorAll(".jsEntryFx");
    this.DOM.primaryItemsSeparators =
      this.DOM.view.querySelectorAll(".fxSeparator");
    this.DOM.primaryItemsChevrons =
      this.DOM.view.querySelectorAll(".fxChevron");
    this.DOM.textsInItems = this.DOM.view.querySelectorAll(".jsTextIn");
    this.DOM.secondary = this.DOM.view.querySelector(".jsSecondaryFx");
    this.DOM.secondaryItems = this.DOM.secondary.querySelectorAll("a");
    this.DOM.secondaryItemsComps = {
      bgs: [],
      logos: [],
      shapes: [],
      logosMobile: [],
    };
    for (let secondary of this.DOM.secondaryItems) {
      this.DOM.secondaryItemsComps.bgs.push(secondary.querySelector(".fxBg"));
      this.DOM.secondaryItemsComps.logos.push(
        secondary.querySelector(".fxLogo svg")
      );
      // this.DOM.secondaryItemsComps.logosMobile.push(secondary.querySelector('.fxLogoMobile img'))
      this.DOM.secondaryItemsComps.shapes.push(
        secondary.querySelector(".fxShape")
      );
    }

    this.DOM.headerMobile = this.DOM.view.querySelector(".fxHeaderMobile");

    this.DOM.slides = this.DOM.view.querySelectorAll(".jsSlide");
    //
    this.FX_VARS = {
      primaryItems: {
        from: {
          y: 65,
          color: "#fff",
        },
        to: {
          color: "#717171",
        },
      },
      textIn: {
        from: {
          y: 0,
        },
        to: {
          y: 20,
        },
      },
      textOut: {
        from: {
          y: -20,
        },
        to: {
          y: 0,
        },
      },
      fill: {
        bg: window
          .getComputedStyle(this.DOM.fill, null)
          .getPropertyValue("background-color"),
      },
      bgs: {
        y: "150%",
      },
    };

    // Flags
    this.IS_ANIMATING = false;
    this.CURRENT_SLIDE = -1;

    this.IS_TRANSITIONING = false;
    // Fns
    this.events();

    this.mount();
  }

  mount() {
    gsap.set(this.DOM.secondary, { autoAlpha: 1 });
    gsap.set(this.DOM.secondaryItems, { autoAlpha: 0 });
    gsap.set(this.DOM.primaryItems, {
      autoAlpha: 1,
      y: this.FX_VARS.primaryItems.from.y,
    });
    gsap.set(this.DOM.secondaryItemsComps.logos, { y: 25 });

    this.setupTexts();
  }

  close(funcStart = null, funcComplete = null) {
    this.out(
      () => {
        Channels.emit("mainnav::closing");
        this.IS_ANIMATING = true;
        this.DOM.view.classList.remove("is--active");
        Env.$html.classList.remove("mainnav--isOpened");
        Env.$html.classList.add("mainnav--isLeaving");
        Env.$html.classList.remove("mainnav--isFinalize");
        if (typeof funcStart == "function" || funcStart != null) funcStart();
      },
      () => {
        this.IS_ANIMATING = false;
        Env.$html.classList.remove("mainnav--isLeaving");
        Env.$html.classList.remove("mainnav--isFinalize");
        if (typeof funcComplete == "function" || funcComplete != null)
          funcComplete();
      }
    );
  }

  events() {
    var self = this;

    for (const e of this.DOM.triggers) {
      e.addEventListener(
        "click",
        () => {
          if (this.IS_ANIMATING == false) {
            this.toggle();
          }
          return false;
        },
        false
      );
    }

    Channels.on("mainnav::close", () => {
      this.close();
    });

    Channels.on("statechange::before", () => {
      this.IS_TRANSITIONING = true;
    });

    Channels.on("statechange::finalize", () => {
      this.IS_TRANSITIONING = false;
    });

    if (Env.mobileCSS) {
      this.DOM.triggerModel.addEventListener("click", () => {
        this.moveSlideshowModel(true);
      });
      this.DOM.triggerCloseModel.addEventListener("click", () => {
        this.moveSlideshowModel(false);
      });
    }

    if (Env.mobileCSS == false) {
      this.hoverFX();
    }
  }

  moveSlideshowModel(state) {
    const viewport = Env.framework.toolbox.getViewport();
    const getPaddingX = parseInt(
      window
        .getComputedStyle(this.DOM.navSlideshow, null)
        .getPropertyValue("padding-left")
    );
    const posX = (viewport.width + getPaddingX) * -1;
    if (state) {
      Env.$html.classList.add("hide-ui");
      const tl = gsap.timeline();
      tl.add(
        gsap.to(this.DOM.navSlideshow, {
          left: posX,
          duration: 0.6,
          ease: "cubic.out",
        })
      ).add(
        gsap.fromTo(
          this.DOM.headerMobile,
          {
            y: "-100%",
          },
          {
            y: "0%",
            duration: 0.5,
            ease: "cubic.inOut",
          }
        ),
        "-=.3"
      );
    } else {
      Env.$html.classList.remove("hide-ui");
      gsap.to(this.DOM.navSlideshow, {
        left: 0,
        duration: 0.6,
        ease: "cubic.out",
      });
    }
  }

  getStatus() {
    return this.DOM.view.classList.contains("is--active");
  }

  hoverFX() {
    this.DOM.menu.addEventListener("mouseenter", () => {
      gsap.to(this.DOM.primaryItems, {
        color: this.FX_VARS.primaryItems.to.color,
        duration: 0.5,
        ease: "cubic.out",
      });
    });
    this.DOM.menu.addEventListener("mouseleave", () => {
      gsap.to(this.DOM.primaryItems, {
        color: this.FX_VARS.primaryItems.from.color,
        duration: 0.5,
        ease: "cubic.out",
      });
    });

    //! Hover Txt Main nav
    for (const [i, item] of this.DOM.primaryItems.entries()) {
      item.addEventListener("mouseenter", () => {
        const getTextIn = this.FX.textsInItems[i];
        const getTextOut = this.FX.textsOutItems[i];
        const DOM = {};
        DOM.textOut = item.querySelector(".jsTextOut");
        item.parentElement.classList.add("is-hovered");
        this.tlHover = gsap.timeline();
        this.tlHover.add([
          gsap.to(DOM.textOut, {
            color: this.FX_VARS.primaryItems.from.color,
            duration: 0.5,
            ease: "cubic.out",
          }),
          gsap.fromTo(
            getTextIn.chars,
            {
              y: this.FX_VARS.textIn.from.y,
            },
            {
              y: this.FX_VARS.textIn.to.y,
              duration: 0.3,
              ease: "quart.inOut",
              stagger: 0.01,
            }
          ),
          gsap.fromTo(
            getTextOut.chars,
            {
              y: this.FX_VARS.textOut.from.y,
            },
            {
              y: this.FX_VARS.textOut.to.y,
              duration: 0.3,
              ease: "quart.inOut",
              stagger: 0.01,
            }
          ),
        ]);
      });
      item.addEventListener("mouseleave", () => {
        if (this.IS_TRANSITIONING == false) {
          item.parentElement.classList.remove("is-hovered");
          this.tlHover.reverse();
        }
      });
    }

    //! Model Nav
    for (const [i, item] of this.DOM.secondaryItems.entries()) {
      hoverIntent(
        item,
        //! IN
        () => {
          Env.$html.classList.add("mainnav-isHovered");
          this.showSlide(i);
          //! OUT
        },
        () => {
          this.resetLogoPath(
            this.DOM.secondaryItemsComps.logos[i].querySelectorAll("path")
          );
          this.resetShapePath(
            this.DOM.secondaryItemsComps.shapes[i].querySelectorAll("path")
          );
          // this.resetBgEntry(this.DOM.secondaryItemsComps.bgs[i],'rgba(43,46,47,.2)')
        }
      ).options({
        timeout: 0,
        interval: 0,
      });
    }

    hoverIntent(
      this.DOM.secondary,
      //! IN
      () => {
        //! OUT
      },
      () => {
        Env.$html.classList.remove("mainnav-isHovered");
        this.resetSlideshow();
      }
    ).options({
      timeout: 0,
      interval: 0,
    });
  }

  in(funcStart = "", funcComplete = "") {
    let tl = gsap.timeline({
      onStart: () => {
        this.status = "animating";
        if (typeof funcStart == "function" || funcStart != null) funcStart();
      },
      onComplete: () => {
        this.status = "in";
        Env.$html.classList.add("mainnav--isFinalize");
        if (typeof funcComplete == "function" || funcComplete != null)
          funcComplete();
      },
    });

    tl.add(() => {
      gsap.set(this.DOM.secondaryItems, { autoAlpha: 1 });
    });
    tl.add([
      gsap.fromTo(
        this.DOM.fill,
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1,
          ease: "expo.inOut",
          duration: 1.2,
        }
      ),
    ]);
    tl.add(
      [
        gsap.fromTo(
          this.DOM.primaryItems,
          {
            autoAlpha: 1,
          },
          {
            y: 0,
            ease: "quint.out",
            duration: 1,
            stagger: 0.05,
          }
        ),
        gsap.fromTo(
          this.DOM.primaryItemsSeparators,
          {
            scaleX: 0,
            transformOrigin: "left center",
          },
          {
            scaleX: 1,
            ease: "quint.out",
            duration: 1,
            stagger: 0.2,
          }
        ),
        gsap.fromTo(
          this.DOM.primaryItemsChevrons,
          {
            autoAlpha: 0,
          },
          {
            autoAlpha: 1,
            ease: "cubic.out",
            duration: 1,
            stagger: 0.2,
            delay: 0.5,
          }
        ),
        gsap.fromTo(
          this.DOM.secondaryItemsComps.bgs,
          {
            y: this.FX_VARS.bgs.y,
            skewY: 20,
          },
          {
            skewY: 0,
            y: 0,
            duration: 0.7,
            ease: "quint.out",
            stagger: 0.1,
            delay: 0.1,
          }
        ),
        gsap.fromTo(
          this.DOM.secondaryItemsComps.logos,
          {
            y: 25,
          },
          {
            y: 0,
            duration: 0.7,
            ease: "cubic.out",
            stagger: 0.1,
            delay: 0.5,
          }
        ),
        gsap.fromTo(
          this.DOM.secondaryItemsComps.shapes,
          {
            autoAlpha: 0,
          },
          {
            autoAlpha: 0.5,
            duration: 0.7,
            ease: "cubic.out",
            stagger: 0.1,
            delay: 0.5,
          }
        ),
        gsap.fromTo(
          this.DOM.close,
          {
            scale: 0,
            autoAlpha: 1,
          },
          {
            scale: 1,
            duration: 0.7,
            ease: "quart.out",
          }
        ),
      ],
      "-=.5"
    );
  }

  out(funcStart = "", funcComplete = "") {
    let tl = gsap.timeline({
      onStart: () => {
        this.status = "animating";

        Env.$html.classList.add("mainnav--isLeaving");

        for (const item of this.FX.textsInItems) {
          gsap.set(item.chars, { clearProps: "y" });
        }

        gsap.delayedCall(0.1, () => {
          this.resetTextOut();
        });

        gsap.set(this.DOM.textOutItems, { clearProps: "color" });
        if (typeof funcStart == "function" || funcStart != null) funcStart();
      },
      onComplete: () => {
        this.status = "out";
        gsap.delayedCall(0.1, () => {
          this.resetTextOut();
        });
        this.moveSlideshowModel(false);
        if (typeof funcComplete == "function" || funcComplete != null)
          funcComplete();
      },
    });

    tl.add([
      gsap.to(this.DOM.close, {
        scale: 0,
        duration: 0.7,
        ease: "quart.inOut",
      }),
      gsap.to(this.DOM.headerMobile, {
        y: "-100%",
        duration: 0.6,
        ease: "cubic.inOut",
      }),
      gsap.to(this.DOM.secondaryItemsComps.bgs, {
        skewY: 20,
        y: this.FX_VARS.bgs.y,
        duration: 0.7,
        ease: "quint.inOut",
        stagger: -0.1,
        delay: 0.5,
      }),
      gsap.to(this.DOM.secondaryItemsComps.logos, {
        y: -25,
        duration: 0.7,
        ease: "cubic.out",
        stagger: -0.1,
      }),
      gsap.to(this.DOM.secondaryItemsComps.shapes, {
        autoAlpha: 0.0,
        duration: 0.7,
        ease: "cubic.out",
        stagger: -0.1,
      }),
    ]);
    tl.add(
      [
        gsap.to(this.DOM.primaryItemsSeparators, {
          scaleX: 0,
          ease: "quint.out",
          duration: 0.3,
          stagger: -0.01,
        }),
        gsap.to(this.DOM.primaryItemsChevrons, {
          autoAlpha: 0,
          ease: "cubic.out",
          duration: 0.3,
          stagger: -0.01,
        }),
        gsap.to(this.DOM.primaryItems, {
          y: this.FX_VARS.primaryItems.from.y,
          ease: "quint.out",
          duration: 1,
          stagger: -0.05,
        }),
      ],
      "-=.5"
    ).add(() => {
      gsap.killTweensOf(this.DOM.fill);
      gsap.to(this.DOM.fill, {
        autoAlpha: 0,
        ease: "cubic.inOut",
        duration: 0.6,
      });
    });
  }

  setupTexts() {
    this.FX = {};
    this.FX.textsInItems = [];
    this.FX.textsOutItems = [];
    this.DOM.textOutItems = [];
    for (let item of this.DOM.textsInItems) {
      let DOM = {};
      const getText = item.innerHTML;
      DOM.textOut = document.createElement("span");
      DOM.textOut.classList.add("jsTextOut");
      DOM.textOut.classList.add("tw-absolute");
      DOM.textOut.classList.add("tw-left-0");
      DOM.textOut.classList.add("tw-top-0");
      DOM.textOut.innerHTML = getText;
      item.parentElement.appendChild(DOM.textOut);
      this.FX.textsOutItems.push(new SplitText(DOM.textOut, { type: "chars" }));
      this.FX.textsInItems.push(new SplitText(item, { type: "chars" }));
      this.DOM.textOutItems.push(DOM.textOut);
    }
  }

  showSlide(i, animate = true) {
    if (animate == true) {
      if (i != this.CURRENT_SLIDE) {
        const DOM = {};
        DOM.new = this.DOM.slides[i];
        DOM.logo = this.DOM.secondaryItemsComps.logos[i];
        DOM.shape = this.DOM.secondaryItemsComps.shapes[i];
        DOM.bg = this.DOM.secondaryItemsComps.bgs[i];
        this.CURRENT_SLIDE = i;

        gsap.to(this.DOM.fill, {
          backgroundColor: DOM.new.getAttribute("data-hoverbg"),
          ease: "cubic.out",
          duration: 0.8,
        });
        gsap.to(DOM.logo.querySelectorAll("path"), {
          fill: DOM.new.getAttribute("data-hoverbg"),
          ease: "cubic.out",
          duration: 0.5,
        });
        gsap.to(DOM.shape.querySelectorAll("path"), {
          stroke: "#343C3F",
          ease: "cubic.out",
          duration: 0.5,
        });
      }
    }
  }

  toggle(_status) {
    if (typeof _status === "undefined")
      _status = this.DOM.view.classList.contains("is--active");

    if (!!_status) {
      this.close();
    } else {
      this.in(
        () => {
          this.IS_ANIMATING = true;
          this.DOM.view.classList.add("is--active");
          Env.$html.classList.add("mainnav--isOpened");
        },
        () => {
          this.IS_ANIMATING = false;
        }
      );
    }
  }

  resetTextOut() {
    for (const item of this.FX.textsOutItems) {
      gsap.killTweensOf(item.chars);
      gsap.set(item.chars, { clearProps: "y" });
    }
  }

  resetSlideshow() {
    this.CURRENT_SLIDE = -1;
    gsap.killTweensOf(this.DOM.fill);
    gsap.to(this.DOM.fill, {
      backgroundColor: this.FX_VARS.fill.bg,
      ease: "cubic.out",
      duration: 0.5,
    });

    for (const [i, logo] of this.DOM.secondaryItemsComps.logos.entries()) {
      this.resetLogoPath(logo.querySelectorAll("path"));
      this.resetShapePath(
        this.DOM.secondaryItemsComps.shapes[i].querySelectorAll("path")
      );
    }
  }

  resetBgEntry(el, color) {
    gsap.killTweensOf(el, color);
    gsap.to(el, {
      backgroundColor: color,
      ease: "cubic.out",
      duration: 0.3,
    });
  }

  resetLogoPath(el) {
    gsap.killTweensOf(el);
    gsap.to(el, {
      fill: "#fff",
      ease: "cubic.out",
      duration: 0.3,
    });
  }

  resetShapePath(el) {
    gsap.killTweensOf(el);
    gsap.to(el, {
      stroke: "#fff",
      ease: "cubic.out",
      duration: 0.3,
    });
  }
}

export default MainnavTouch;
